// src/components/Elements/Loader/Loader.jsx
import React from "react";
import "./loader.css";

const Loader = () => (
  <div id="loader-overlay">
    <div className="loader">
      <div className="loader-dot" />
      <div className="loader-dot" />
      <div className="loader-dot" />
    </div>
  </div>
);

export default Loader;